import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetSignUp($uuid: ID!) {
    getSignUp(uuid: $uuid) {
      uuid
      status
      stage
      enquiry {
        firstName
        lastName
        emailAddress
        leadId
        licences
        middleName
        companyName
        option {
          provisioningPeriod
          billingPeriod
          pricePerMonth
          pointsPerYear
          lengthOfContractInMonths
          quoteId
        }
      }
      companyCheck {
        uuid
        outcome {
          alerts {
            message
            severity
          }
          indicator
          score
        }
      }
      individualChecks {
        uuid
        link {
          url
          expires {
            seconds
          }
        }
        outcome {
          alerts {
            message
            severity
          }
          indicator
          score
        }
        ignored
      }
      expiry
    }
  }
`

export const getSignUpKey = getQueryNames(query)[0]

export default query
